import MainAdminInquiryDetail from "../components/admin-inquiries/admin-inquiry-detail";

export default function AdminInquiryDetailPage() {
  return <MainAdminInquiryDetail />;
}
